import { Button, Typography } from "@altimateai/lego";
import { IconPlus } from "@tabler/icons-react";

interface SubscriptionEmptyStateProps {
  onCreateClick: () => void;
}

export const SubscriptionEmptyState = ({ onCreateClick }: SubscriptionEmptyStateProps) => {
  return (
    <div className="al-p-16 al-text-center">
      <Typography variant="body" weight="medium" className="al-mb-2">
        No subscriptions yet
      </Typography>
      <Typography variant="body" className="al-text-gray-500 al-mb-4">
        Create your first subscription to get started
      </Typography>
      <Button onClick={onCreateClick}>
        <IconPlus className="al-h-4 al-w-4 al-mr-2" />
        Create Subscription
      </Button>
    </div>
  );
};
